module.exports = "/_next/static/resources/bouquet-9baf4be7a760abc0e01b1079e1a3eba3.webp";